import { useQuery } from '@tanstack/vue-query';
import { ref, Ref } from 'vue';

import contractFormalization
  from '~/services/contract-formalization-api/contract-formalization-api';
import { queryKeys } from '~/store/queryClient';

export default function useResendSignature(projectId: Ref<string>) {
  const queryKey = ref(queryKeys.CONTRACT_FORMALIZATION.RESEND_SIGNATURE(projectId.value));

  const queryFn = () => contractFormalization.resendSignature(projectId.value);

  const query = useQuery({
    enabled: false,
    queryFn,
    queryKey,
    refetchInterval: 5_000,
    retry: 3,
  });

  return query;
}
